function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  align-self: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import { css } from "@emotion/react";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { PulseLoader } from "react-spinners";
import { selectShowLoading } from "./Store/selectors";
import "./Loading.css"; // CSS pour le loader

var STYLE_LOADER = css(_templateObject()); // #region HOOK

/**
 * Représente le composant de chargement
 * @class
 * @category Loading
 * @param {Loading.propTypes} props Les propriétés du composant
 */

function Loading(props) {
  // Récupération des props
  var color = props.color,
      text = props.text;
  var showLoading = useSelector(function (state) {
    return selectShowLoading(state);
  }); // Interface

  return /*#__PURE__*/React.createElement(Fragment, null, showLoading && /*#__PURE__*/React.createElement("div", {
    className: "Loading-Container"
  }, /*#__PURE__*/React.createElement(PulseLoader, {
    css: STYLE_LOADER,
    sizeUnit: "px",
    size: 35,
    margin: "10px",
    color: color,
    loading: true
  }), /*#__PURE__*/React.createElement("span", {
    className: "Loading-Text",
    style: {
      color: color
    }
  }, text)));
} // #endregion
// #region PROPRIETES

/**
  * Type des propriétés de {@link Loading}
  * @typedef {Object} Loading.propTypes
  * @property {string} [color=#fff] Couleur du loader
  * @property {string} [text=Veuillez patienter...] Texte du loader
  */


Loading.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  text: PropTypes.string
} : {};
/*
  Valeurs par défaut des propriétés
*/

Loading.defaultProps = {
  color: "#fff",
  text: "Veuillez patienter..."
}; // #endregion

export { Loading };